<template>
  <div>
    <div v-if="loadingStatus">
      <v-skeleton-loader
        :loading="loadingStatus"
        class="mb-3 mt-4"
        type="card"
        elevation="2"
      >
      </v-skeleton-loader>
    </div>
    <div v-show="!loadingStatus">
      <v-row class="my-3 mx-2" justify="center">
        <v-col
          cols="12"
          md="3"
          sm="6"
          v-for="item in TeamStack.allTeams"
          :key="item.id"
        >
          <v-sheet elevation="4" shaped class="mt-7 my-2">
            <!-- opp team -->
            <v-row class="mx-2">
              <v-col cols="3" md="3" sm="12">
                <v-avatar size="40" color="#ECEFF1">
                  <img :src="item.AwayTeamLogo" />
                </v-avatar>
                <p class="caption ml-2">{{ item.AwayTeam }}</p>
              </v-col>
              <v-col cols="9" md="9" sm="9">
                <v-slider
                  v-model="item.OpponentRange"
                  :max="Omax"
                  :min="Omin"
                  thumb-size="30"
                  thumb-label
                  class="align-center"
                >
                  <template v-slot:prepend>
                    <p class="caption" v-text="item.OpponentRange"></p>
                  </template>
                  <!-- <template v-slot:append>
                    <p class="caption" v-text="item.OpponentRange[1]"></p>
                  </template> -->
                </v-slider>
              </v-col>
            </v-row>

            <!-- home team -->
            <v-row class="mx-2">
              <v-col cols="3" md="3" sm="12">
                <v-avatar size="40" color="#ECEFF1">
                  <img :src="item.HomeTeamLogo" />
                </v-avatar>
                <p class="caption ml-2">{{ item.HomeTeam }}</p>
              </v-col>
              <v-col cols="9" md="9" sm="9">
                <v-slider
                  v-model="item.HomeRange"
                  :max="Hmax"
                  :min="Hmin"
                  thumb-size="30"
                  thumb-label
                  class="align-center"
                >
                  <template v-slot:prepend>
                    <p class="caption" v-text="item.HomeRange"></p>
                  </template>
                  <!-- <template v-slot:append>
                    <p class="caption" v-text="item.HomeRange[1]"></p>
                  </template> -->
                </v-slider>
              </v-col>
            </v-row>
          </v-sheet>
          <!-- <p>{{ item.HomeRange }}</p> -->
          <!-- <p>{{ item.OpponentRange }}</p> -->
        </v-col>
      </v-row>

      <!-- instruction -->
      <v-col cols="12" md="6" sm="12" class="mx-auto">
        <v-banner color="#0097A7" rounded class="Info-banner">
          <v-row>
            <v-col>
              <p class="body-1 font-weight-bold">
                Instructions
                <v-icon color="#FDD835">mdi-book-information-variant</v-icon
                >&nbsp;<br />
                <span
                  >Team stack allows you to pick players from the same team.
                  Examples:</span
                >
              </p>
            </v-col>
          </v-row>

          <ol class="text-body-2 white--text mt-n4">
            <li>CHI = 4, you will get 4 players from CHI in a build.</li>
            <li>
              CGY = <span class="black--text">2</span>, + CHI =
              <span class="black--text">2</span>, you will get 2 players from
              CGY & 2 players from CHI respectively.
            </li>
          </ol>
        </v-banner>
      </v-col>
      <!-- instruction -->

      <!-- button -->
      <v-row class="ma-5" justify="center" align="center">
        <v-col cols="4" md="2" sm="3" class="text-center w-100">
          <v-btn class="ma-2 mx-auto" color="primary" @click="backButton">
            Back
          </v-btn>
        </v-col>

        <v-col cols="4" md="2" sm="3" class="text-center w-100">
          <v-btn
            class="ma-2 mx-auto"
            color="success"
            @click="onClick(userID, TeamStack, slateId)"
          >
            Save
          </v-btn>
        </v-col>

        <v-col cols="4" md="2" sm="3" class="text-center w-100">
          <v-btn
            class="ma-2 mx-auto white--text"
            color="#E53935"
            @click="resetPlayer"
          >
            Reset
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "NhlTeamStack",
  props: ["slateId"],

  data() {
    return {
      Hmin: 0,
      Hmax: 6,
      Omin: 0,
      Omax: 6,
      /*items: {
          Hrange: [0, 6],
          OpRange: [0, 6],
        },*/
      userID: localStorage.getItem("user"),
    };
  },
  created() {
    let obj = {
      SlateID: this.slateId,
      user: this.userID,
    };
    this.$store.dispatch("NhlModule/getTeamStack", obj);
  },
  computed: {
    ...mapGetters("NhlModule", ["loadingStatus", "getFilterByPosition"]),
    ...mapState("NhlModule", ["TeamStack"]),
  },
  methods: {
    onClick(...args) {
      let filtered_data = [];
      args[1].allTeams.forEach(function (team) {
        filtered_data.push({
          AwayTeam: team.AwayTeamID,
          HomeTeam: team.HomeTeamID,
          HomeRangeMin: team.HomeRange,
          OpponentRangeMin: team.OpponentRange,
        });
      });

      this.$store
        .dispatch("NhlModule/getPlayerPerTeam", {
          slatId: args[2],
          id: args[0],
          allTeams: filtered_data,
        })
        .then(() => {
          this.$router.go(-1);
        });
    },

    resetPlayer() {
      let obj = {
        slatId: this.slateId,
        userId: this.userID,
      };
      this.$store.dispatch("NbaModule/resetPlayers", obj).then(() => {
        let obj = {
          SlateID: this.slateId,
          user: this.userID,
        };
        this.$store.dispatch("NbaModule/getTeamStack", obj);
      });
    },

    backButton() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped></style>
